import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import containerStyles from 'components/ResponsiveLayout/container.module.css'
import styles from './styles.module.css'

type NavLink = {
  label: string
  href: string
  external?: boolean
}

const DEFAULT_NAVIGATION_LINKS: NavLink[] = []

interface HeaderProps {
  showSearch?: boolean
  breadcrumb?: React.ReactNode
  navLinks?: NavLink[]
}

const Header = ({
  showSearch = true,
  breadcrumb,
  navLinks = DEFAULT_NAVIGATION_LINKS,
}: HeaderProps) => {
  const isCompactHeader = false

  return (
    <header className="sticky top-0 z-50 bg-[#2A7EFB]">
      <div
        className={clsx(
          containerStyles['rgtk-page-container'],
          'mx-auto flex w-full flex-col gap-5 md:gap-8 md:!pt-8',
          styles['header-content'],
          isCompactHeader ? styles['compact'] : styles['expanded'],
          isCompactHeader && showSearch && styles['search-hidden']
        )}
      >
        <div
          className={clsx(
            'flex flex-col gap-3 md:flex-row md:items-center md:justify-between',
            styles['header-logo-nav']
          )}
        >
          <Link href="/" passHref legacyBehavior>
            <a className="flex items-center gap-4">
              <img
                src="/images/ruang-gtk/logo-sm-inverse.svg"
                alt="Logo"
                className="h-8 w-auto md:h-10"
              />
              <Text variant="heading-md" color="inverse">
                Ruang Guru dan Tenaga Kependidikan (GTK)
              </Text>
            </a>
          </Link>

          <nav className="hidden items-center gap-6 text-sm font-medium text-white md:flex xl:gap-8">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer hover:opacity-80"
                >
                  <Text variant="heading-md" color="inverse">
                    {link.label}
                  </Text>
                </a>
              ) : (
                <Link key={link.href} href={link.href} passHref legacyBehavior>
                  <a className="cursor-pointer hover:opacity-80">
                    <Text variant="heading-md" color="inverse">
                      {link.label}
                    </Text>
                  </a>
                </Link>
              )
            )}
          </nav>
        </div>

        {showSearch && (
          <div
            className={clsx(
              'w-full',
              styles['header-searchbox'],
              isCompactHeader ? styles['hidden'] : styles['visible']
            )}
          >
            <div className="rounded-lg bg-white px-4 py-3 text-gray-60">
              Cari Layanan..
            </div>
          </div>
        )}

        {!showSearch && breadcrumb && (
          <div className="w-full pb-2">{breadcrumb}</div>
        )}
      </div>
    </header>
  )
}

export default Header
